var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 73.867,
    viewBox: "0 0 78 73.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(var(--secondaryColorRGB),0.2);}.a,.b{stroke:var(--secondaryColor);}.b{fill:var(--bgColor);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-638.63 -344.09)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M716.13,352.41v66h-77v-66h21.22v15.542h10.391V352.41H682.72v15.542h10.391V352.41Z",
    transform: "translate(0 -0.957)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 11.567,
    height: 11.567,
    transform: "translate(682.129 373.231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 11.567,
    height: 11.567,
    transform: "translate(659.76 373.231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 11.567,
    height: 11.567,
    transform: "translate(682.129 394.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 11.567,
    height: 11.567,
    transform: "translate(659.76 394.445)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(685.353 344.59)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5.125,
    height: 19.772
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(662.983 344.59)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5.125,
    height: 19.772
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.62d9ac36b0be9003d6ba0137058372ac.svg";
export { ForwardRef as ReactComponent };